var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIfArrow = function SvgIfArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 40,
    viewBox: "0 0 78 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H62.6645C65.6377 0 68.3657 1.64887 69.7477 4.28133L76.0477 16.2813C77.2701 18.6097 77.2701 21.3902 76.0477 23.7187L69.7477 35.7187C68.3657 38.3511 65.6377 40 62.6645 40H10C4.47715 40 0 35.5228 0 30V10Z",
    fill: "#B77DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0423 26H33.7063V14.8H32.0423V26ZM36.7638 26H38.3158V19.28H40.7478V17.936H38.3158V17.2C38.3158 16.4 38.7958 15.904 39.5318 15.904H40.7478V14.56H39.4198C37.8038 14.56 36.7638 15.568 36.7638 17.152V17.936H35.1158V19.28H36.7638V26Z",
    fill: "#F2F2F7"
  })));
};
export { SvgIfArrow as ReactComponent };
export default __webpack_public_path__ + "if-arrow.svg";